import React from 'react';
import { Box } from '@mui/material';
import "./Infographics.scss";
import ImageView from '../ImageView/ImageView';

const Infographics = (props:any) => {
  const {infographicDesktop,infographicMobile} = props;
  return (
    <Box className="infographicsContainer">
      {/* Desktop Image */}
      <Box className="desktopImage">
        <ImageView src={infographicDesktop} alt="Infographics Desktop" sizes="(max-width: 768px) 960px, 960px"/>
      </Box>

      {/* Mobile Image */}
      <Box className="mobileImage">
        <ImageView src={infographicMobile} alt="Infographics Mobile" sizes="(max-width: 768px) 840px, 840px"/>
      </Box>
    </Box>
  );
};

export default Infographics;